<template>
  <div class="outerCtn" id="main">
    <div>
      <img src="../../../assets/news/banner.png" alt="" width='100%'/>
    </div>
    <div class="likeT">
          <div class="hashover" @click="goPath">资讯动态</div>
          <div style="padding: 0 2px">>></div>
          <div> {{news.type == 1 ?' 小鳗动态' : news.type == 2?'行业资讯':'小鳗课堂'}} </div>
    </div>
    <div class="phone_title">{{news.title}}</div>
    <div v-html="news.content" class="phone_content"></div>
    <div class="left">
        <div style="line-height:20px;">
        上一篇：<span @click="toDetailone(list[noeIndex-1])" class="title">{{list[noeIndex-1] ?list[noeIndex-1] .title :'没有了！'}}</span>
        </div>
        <div style="margin-top:10px;line-height:20px;">
          下一篇：<span  @click="toDetailone(list[noeIndex+1])" class="title">{{list[noeIndex+1] ?list[noeIndex+1] .title :'没有了！'}}</span>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      news: '',
      noeIndex: 0,
      list: []
    }
  },
  watch: {

    '$route'(to, from) {
      console.log(111111)
      const timestamp = this.timetep();
      const meta = document.querySelector('meta[name="update_time"]');
      if (meta) {
        meta.setAttribute('content', timestamp);
      } else {
        const newMeta = document.createElement('meta');
        newMeta.setAttribute('name', 'update_time');
        newMeta.setAttribute('content', timestamp);
        document.head.appendChild(newMeta);
      }
      let id = this.$route.params.id.split("_")[1]
      this.getNew(id.split(".")[0]|| '')
      this.getNew()
      document.getElementById("main").scroll(0, 0);

    }
  },
  mounted(){
    let id = this.$route.params.id.split("_")[1]
    this.getNew(id.split(".")[0]|| '')
    this.getData()
    document.getElementById("main").scroll(0, 0);
  },
  methods: {
    toDetailone(item){
      this.$router.push({
        path: '/newDetail/'+ item.type + '_' + item.aid + '.html'
      })
    },
    findNext(list){
      this.list.forEach((ele,index)=>{
        if(ele.aid == this.news.aid){
          this.noeIndex = index
        }
      })
      console.log(this.noeIndex)
    },
    getData () {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 9999);
      params.append("type",this.$route.params.id.split("_")[0]);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.list = JSON.parse(JSON.stringify(res.data.data.records));
        this.findNext()

      });
    },
    getNew(id){
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 1);
      params.append('aid', id);
      this.$axios.post('/api/websiteNews/websiteList',params).then(res=>{
        this.news = res.data.data.records[0]
      })
    },
    goPath(){
      this.$router.push({
        path: '/phoneNews'
      })
    },
  },
}
</script>

<style>

.likeT{
  margin-top:20px; margin-bottom:10px;border-bottom:1px solid #ccc;padding-bottom:10px;font-size: 14px;
  display: flex;
}

  .outerCtn{
    background-color:#23262A ;
    color: white;
    min-height: 100vh;
    padding: 0 10px;
    color: white !important;
  }
  .phone_title{
    font-weight: 600;
    padding: 20px;
    padding-bottom: 0;
    text-align: left;
    line-height: 24px;
    font-size: 22px;
  }
  .phone_content{
    text-align: left;
    color: white;
    padding: 18px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }
  .phone_content p{
    line-height: 20px;
  }
  .phone_content img{
    width: 97%;
    height: auto;
    color: white;
  }

  .left {
  text-align: left;
  font-size: 15px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneNewsDetail.vue